import * as React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import UserDetailTopBar from "app/components/AppComponents/SnapScan/Ops/DashboardsTopBar";
import {
  SumoLogicDashboard,
  dashboards
} from "app/components/AppComponents/Dashboards";

const Users = props => (
  <Switch>
    <Route
      exact={true}
      path="/snapscan/ops/dashboards"
      render={() => (
        <Redirect to={`/snapscan/ops/dashboards/${dashboards[0].name}`} />
      )}
    />
    <Route
      exact={true}
      path="/snapscan/ops/dashboards/:name"
      render={routerProps => (
        <>
          <UserDetailTopBar />
          <section className="padded scrollable">
            <div style={{ height: "100%" }}>
              <SumoLogicDashboard name={routerProps.match.params.name} />
              <div style={{ textAlign: "center" }}>
                If you don't see a dashboard on this page, try whitelisting this
                site in your adblocker.
              </div>
            </div>
          </section>
        </>
      )}
    />
  </Switch>
);

export default Users;
